import React, { useEffect } from 'react';
import mobileDetect from '@utils/misc/mobileDetect';
import { TOOLS } from '../control-panel/Toolbar';

// enable brush mode
// only for non mobile browser
// and for tools other than annotate
function useCursor({ instance, activeTool, additionalTriggerDeps = [] }: any) {
  const updateCursor = React.useCallback(
    ({ activeTool }) => {
      if (instance) {
        // disable brush for annotation mode
        if (activeTool === TOOLS.annotate || activeTool === TOOLS.noTool) {
          instance.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'brush',
            brushOption: {
              // `brushType` set as `false`, to disable mouse is to brush.
              brushType: false,
            },
          });
        } else {
          instance.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'brush',
            brushOption: {
              brushType: 'lineX',
              brushMode: 'single',
            },
          });
        }
      }
    },
    [instance],
  );

  useEffect(() => {
    updateCursor({ activeTool });
  }, [updateCursor, activeTool, ...additionalTriggerDeps]);

  return { updateCursor };
}

export default useCursor;
